import {Sidebar} from "primereact/sidebar";
import {useContext, useRef} from "react";
import {LayoutContext} from "./context/LayoutContext";
import {baseUrl} from "../../utils/webInfo";
import callToast from "../../utils/helper";
import {Toast} from "primereact/toast";
import {useAuth} from "../../hooks/useAuth";


const AppProfileSidebar = () => {
    const {layoutState, setLayoutState} = useContext(LayoutContext);
    // const navigate = useNavigate();
    // const {accessToken, setAccessToken} = useContext(LayoutContext);
    const toast = useRef<Toast | null>(null);
    const { accessToken, setAccessToken } = useAuth();

    const onProfileSidebarHide = () => {
        setLayoutState((prevState) => ({
            ...prevState,
            profileSidebarVisible: false,
        }));
    };

    const handleLogout = async () => {
        try {
            const res = await fetch(`${baseUrl.url}/auth/logout`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    // 'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            });

            if (!res.ok) {
                const text = await res.text();
                callToast(toast, false, `Logout failed: ${text || res.status}`);
                return;
            }

            localStorage.removeItem('isLogin');
            setAccessToken('');
            callToast(toast, true, "Logged out successfully");


            setTimeout(() => {
                window.location.href = '/';
            }, 500);
        } catch (error) {
            callToast(toast, false, 'Network error during logout');
            console.error(error);
        }
    };


    return (
        <Sidebar
            visible={layoutState.profileSidebarVisible}
            onHide={onProfileSidebarHide}
            position="right"
            className="layout-profile-sidebar w-full sm:w-25rem"
        >
            <Toast ref={toast}/>

            <div className="flex flex-column mx-auto md:mx-0">
                <span className="mb-2 font-semibold">Welcome</span>
                <span className="text-color-secondary font-medium mb-5">
                    Admin
                </span>

                <ul className="list-none m-0 p-0">
                    <li>
                        <div
                            className="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
                            <span>
                                <i className="pi pi-user text-xl text-primary"></i>
                            </span>
                            <div className="ml-3">
                                <span className="mb-2 font-semibold">
                                    Profile
                                </span>
                                {/*<p className="text-color-secondary m-0">*/}
                                {/*    Lorem ipsum date visale*/}
                                {/*</p>*/}
                            </div>
                        </div>
                    </li>

                    <li>
                        <div
                            className="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150"
                            onClick={handleLogout}
                        >
                            <span>
                                <i className="pi pi-power-off text-xl text-primary"></i>
                            </span>
                            <div className="ml-3">
                                <span className="mb-2 font-semibold">
                                    Sign Out
                                </span>
                                {/*<p className="text-color-secondary m-0">*/}
                                {/*    Sed ut perspiciatis*/}
                                {/*</p>*/}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </Sidebar>
    );
};

export default AppProfileSidebar;
